import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const C = { primary:"#f97316", dark:"#ea580c", white:"#ffffff", bg:"#f2f2f7", text:"#1c1c1e", sub:"#6b7280", border:"#e5e7eb" };

function Section({ title, children }) {
  return (
    <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:14, border:`1px solid ${C.border}` }}>
      <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1rem", marginBottom:10, color:C.dark }}>{title}</div>
      <div style={{ fontSize:"0.85rem", color:C.sub, lineHeight:1.8 }}>{children}</div>
    </div>
  );
}

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',system-ui,sans-serif", background:C.bg, minHeight:"100vh", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}`}</style>

      <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"14px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex" }}><ArrowLeft size={22} color={C.text}/></button>
        <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.15rem" }}>Privacy Policy</div>
      </div>

      <div style={{ maxWidth:640, margin:"0 auto", padding:"24px 20px 48px" }}>

        <div style={{ background:`linear-gradient(135deg,${C.dark},${C.primary})`, borderRadius:16, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ color:"#fff", fontWeight:800, fontSize:"1rem", marginBottom:4 }}>Privacy Policy — Quickry</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:"0.78rem" }}>Last updated: January 2025 | Effective immediately</div>
        </div>

        <Section title="1. Introduction">
          Quickry ("we", "us", or "our") operates a hyperlocal delivery platform based in Akola, Maharashtra. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application or website (collectively, the "Platform"). By using our Platform, you consent to the practices described in this policy.
        </Section>

        <Section title="2. Information We Collect">
          <strong style={{ color:C.text }}>Personal Information:</strong> Name, phone number, email address, delivery addresses.<br/><br/>
          <strong style={{ color:C.text }}>Location Data:</strong> With your permission, we collect your real-time location to enable accurate delivery and show nearby restaurants/stores.<br/><br/>
          <strong style={{ color:C.text }}>Order Information:</strong> Items ordered, payment method (we do not store card details), order history, preferences.<br/><br/>
          <strong style={{ color:C.text }}>Device Information:</strong> Device type, operating system, browser type, IP address, and app usage data for analytics and security purposes.
        </Section>

        <Section title="3. How We Use Your Information">
          We use the collected information to:<br/>
          • Process and fulfill your orders<br/>
          • Send order updates and delivery notifications<br/>
          • Improve our services and user experience<br/>
          • Detect and prevent fraud<br/>
          • Respond to customer support queries<br/>
          • Comply with legal obligations<br/>
          • Send promotional offers (with your consent, which you can withdraw anytime)
        </Section>

        <Section title="4. Information Sharing">
          We do not sell your personal information. We may share data with:<br/><br/>
          <strong style={{ color:C.text }}>Delivery Partners (Riders):</strong> Your name, phone number, and delivery address are shared with assigned delivery riders.<br/><br/>
          <strong style={{ color:C.text }}>Restaurants/Stores:</strong> Order details are shared with the vendor to prepare your order.<br/><br/>
          <strong style={{ color:C.text }}>Payment Processors:</strong> We use Paytm Payment Gateway. Card/UPI details are handled directly by Paytm and not stored by us.<br/><br/>
          <strong style={{ color:C.text }}>Legal Requirements:</strong> We may disclose information if required by law or court order.
        </Section>

        <Section title="5. Payment Security">
          All payments are processed through Paytm Payment Gateway, which uses industry-standard encryption (SSL/TLS). We do not store your credit/debit card numbers or CVV. Payment data is handled directly by Paytm in compliance with PCI-DSS standards.
        </Section>

        <Section title="6. Data Retention">
          We retain your personal data for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data by contacting us at hello.quickry@gmail.com. We will process deletion requests within 30 days.
        </Section>

        <Section title="7. Your Rights">
          You have the right to:<br/>
          • Access the personal data we hold about you<br/>
          • Correct inaccurate information<br/>
          • Request deletion of your data<br/>
          • Withdraw consent for marketing communications<br/>
          • Lodge a complaint with the relevant data protection authority
        </Section>

        <Section title="8. Cookies">
          Our Platform uses cookies and similar tracking technologies to enhance your experience. You can disable cookies through your browser settings, though this may affect Platform functionality.
        </Section>

        <Section title="9. Children's Privacy">
          Our Platform is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.
        </Section>

        <Section title="10. Changes to This Policy">
          We may update this Privacy Policy from time to time. We will notify you of significant changes via email or in-app notification. Continued use of our Platform after changes constitutes acceptance.
        </Section>

        <Section title="11. Contact Us">
          For any privacy-related queries or to exercise your rights, contact us at:<br/><br/>
          <strong style={{ color:C.text }}>Email:</strong> hello.quickry@gmail.com<br/>
          <strong style={{ color:C.text }}>Address:</strong> Near Khandelwall School Old city Dabki Road, Akola, Maharashtra — 444001, India
        </Section>

      </div>
    </div>
  );
}